import React from "react";
import { DropdownMenuItem } from "src/components/ui/dropdown-menu";
import { OverviewBirthdaySummary } from "src/pages/Overview/api/interfaces";
import useBirthdayListNavigation from "src/pages/Overview/hooks/useBirthdayListNavigation";

interface BirthdayDropdownMenuItemProps {
  birthdate: `Today's` | `Tomorrow` | `Upcoming`;
  summary: OverviewBirthdaySummary;
}

const BirthdayDropdownMenuItem: React.FC<BirthdayDropdownMenuItemProps> = ({
  birthdate,
  summary,
}) => {
  const tab =
    birthdate === `Today's`
      ? `today`
      : birthdate === `Tomorrow`
        ? `tomorrow`
        : `upcoming`;

  const { handleNavigateNotification } = useBirthdayListNavigation({ tab });

  return (
    <DropdownMenuItem
      className="flex flex-col gap-1.5 items-start border-b py-3"
      onClick={handleNavigateNotification}
    >
      <span className="text-sm font-semibold text-darkBrown-default">
        {birthdate + ` Birthday`}
      </span>
      <span className="text-md text-darkBrown-default">
        {summary.summary}
      </span>
    </DropdownMenuItem>
  );
};

export default BirthdayDropdownMenuItem;
